export const getSearchParams = (paramName: string): null | string => {
  const urlSearchParams = new URLSearchParams(window.location.search);

  return urlSearchParams.get(paramName);
};
